import { generateUUID } from 'shared/helpers/utils/generate-uuid';
import { TableFilterFieldType } from 'common/TableFilter';
import type { TableFilterField } from 'common/TableFilter';

export const buildingsFilterFields: TableFilterField[] = [
  {
    key: generateUUID(),
    name: 'name',
    label: 'Наименование здания',
    type: TableFilterFieldType.INPUT,
  },
  {
    key: generateUUID(),
    name: 'address',
    label: 'Адрес',
    type: TableFilterFieldType.INPUT,
  },
  {
    key: generateUUID(),
    name: 'roomCount',
    label: 'Количество аудиторий',
    type: TableFilterFieldType.NUMBER,
    min: 0,
    precision: 0,
  },
];
